<template>
  <div
    class="flex h-[14px] rounded-lg cursor-pointer>">
    <span
    class="font-pretendard font-medium text-[14px] text-textPrimary leading-[83%] tracking-normal align-middle cursor-pointer">
      문의하기
    </span>
  </div>
</template>

<script>
export default {}
</script>
